export default __webpack_public_path__ + "static/media/EM0870.34I-22722_-15179_0.fd623b22.jpg";